import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page" }

import PageHeader from '@/shared/components/pageHeader/PageHeader.vue';
import { TabItem } from '@/shared/components/pageHeader/tabItem';
import { useStore } from 'vuex';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Settings',
  setup(__props) {

const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);

const tabs: TabItem[] = [
  { name: 'General', route: 'general-settings' },
  { name: 'Teammates', route: 'teammates' },
  { name: 'Email', route: 'email' },
  { name: 'Business Hours', route: 'business-hours' },
  { name: 'Contact Attributes', route: 'contact-attributes' },
];

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageHeader, {
      title: "Settings",
      description: currentWorkspace.value.name,
      tabs: tabs
    }, null, 8, ["description"]),
    _createVNode(_component_router_view)
  ]))
}
}

})